const VueAxiosPlugin = {}
export default VueAxiosPlugin.install = function(app, { axios }) {
  try {
    const csrf_token = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content')

    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrf_token
    }
  } catch (e) {
    // test 環境ではCSRFトークンを生成しないため、エラーを出力して後続処理を継続する
    console.log(e)
  }

  Object.defineProperties(app.config.globalProperties, {
    axios: {
      get() {
        return axios
      }
    }
  })
}
